const initSettingModal = ({ target }) => {
  const onClickOpenCreateModal = () => {
    const createButton = $(`.js-${target}-create-btn`)

    createButton.on('click', () => {
      const modal = $(`.js-${target}s-modal`)
      if (isModalOpen(modal)) return

      let e = $(window).scrollTop()
      modal.addClass('is-active').css("top", e + 100).fadeIn(300).scrollTop(0).attr("aria-hidden", "false")
      modal.show()
    })
  }

  const onClickOpenEditModals = () => {
    const editButtons = $(`.js-${target}-edit-btn`)

    editButtons.each((_, button) => {
      const editButton = $(button)

      editButton.on('click', () => {
        const id = getId(editButton, `js-${target}-edit-btn-id`)

        const modal = $(`.js-${target}s-modal${id}`)
        if (isModalOpen(modal)) return

        let e = $(window).scrollTop()
        modal.addClass('is-active').css("top", e + 100).fadeIn(300).scrollTop(0).attr("aria-hidden", "false")
        modal.show()
      })
    })
  }

  const onClickOpenDeleteModals = () => {
    const deleteButtons = $(`.js-${target}-delete-btn`)

    deleteButtons.each((_, button) => {
      const deleteButton = $(button)

      deleteButton.on('click', () => {
        const id = getId(deleteButton, `js-${target}-delete-btn-id`)

        const modal = $(`.js-${target}s-delete-modal${id}`)
        if (isModalOpen(modal)) return

        let e = $(window).scrollTop()
        modal.addClass('is-active').css("top", e + 100).fadeIn(300).scrollTop(0).attr("aria-hidden", "false")
        modal.show()
      })
    })
  }

  const onClickCloseModal = () => {
    const closeButtons = $(`.js-${target}-modal-close-btn`)

    closeButtons.each((_, button) => {
      const closeButton = $(button)

      closeButton.on('click', () => {
        const id = getId(closeButton, `js-${target}-modal-close-btn-id`)

        const modal = $(`.js-${target}s-modal${id}`)
        const isModalClosed = !isModalOpen(modal)

        if (isModalClosed) return

        modal.hide()
        $('body').removeClass('is-fixed')
      })
    })
  }

  const onClickCloseDeleteModal = () => {
    const closeButtons = $(`.js-${target}-delete-modal-close-btn`)

    closeButtons.each((_, button) => {
      const closeButton = $(button)

      closeButton.on('click', () => {
        const id = getId(closeButton, `js-${target}-delete-modal-close-btn-id`)

        const modal = $(`.js-${target}s-delete-modal${id}`)
        const isModalClosed = !isModalOpen(modal)

        if (isModalClosed) return

        modal.hide()
        $('body').removeClass('is-fixed')
      })
    })
  }

  const isModalOpen = (target) => {
    return target.css('display') !== 'none'
  }

  const getId = (element, prefix) => {
    const classNames = element.attr('class').split(' ')
    const elementId = classNames.find(className =>
      className.includes(prefix)
    )

    return elementId.replace(prefix, '')
  }

  return { onClickOpenCreateModal, onClickOpenEditModals, onClickOpenDeleteModals, onClickCloseModal, onClickCloseDeleteModal }
}

export default initSettingModal
